/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { buildUrl } from "../../utils/bindUrl";
import {
  IResponseListTeams,
  IResponseShowTeam,
  ITeam,
} from "../../interfaces/teams";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/teams";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listTeams({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListTeams>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showTeam({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowTeam>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createTeam({ team }: { team: ITeam }) {
  const { data } = await api.post<IResponseShowTeam>(BASE, { team });
  return data;
}

export async function updateTeam({
  id,
  team,
}: {
  id: string | number;
  team: ITeam;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowTeam>(url, { team });
  return data;
}

export async function updateTeamAddUser({
  id,
  team,
}: {
  id: string | number;
  team: { idUser: string };
}) {
  const url = buildUrl(`${BASE}/{id}/user`, { id });
  const { data } = await api.put<IResponseShowTeam>(url, { team });
  return data;
}

export async function deleteTeam({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
